const menu = [
	{
		id: 'illustration',
		label: 'Illustration',
		submenu: [
			{
				id: 'editorial',
				label: `Editorial`,
				projects: [
					'dox_gradMedHum',
					'dox_AIcollage2',
					'dox_microbiome_collage',
					'dox_split_color_pill',
					'dox_collage_GLP_positive',
					'dox_iceberg_pouch',
					'dox_AIcollage1',
					'dox_US_vs_Austria_OR',
					'dox_hospital_closures_collage',
					'dox_calendar_squeeze',
					'dox_private_practice',
					'dox_explore_text',
					'dox_drowning_under_stetho',
					'dox_leave_the_nest',
					'dox_self_collage',
					'dox_ignore_patient_huddle',
					'dox_gamePlan_map',
					'dox_flowchart_construction',
					'dox_direction_sign',
					//'dox_hospital_closures_illo',
					'dox_stage_fright',
					'dox_match_envelope_mountains',
					'dox_boardgame',
					'dox_business_yin_yang',
					'dox_job_turnover',
					'dox_collage_fines',
					'dox_blackbox_warning',
					'dox_collage_GLP',
					'dox_title_marquee',
					'dox_FDA_fast_track',
					//'dox_WIM_group_animation',
					'dox_collage_edit_article',
					'dox_pill_shadow',
					'dox_paper_mountains',
					'dox_snake_signature',
					'dox_lawsuit_gavel',
					'dox_study_recruitment',
					'dox_robot_stage',
					'dox_med_school_rankings',
					'dox_side_gigs',
					'dox_good_v_bad_feedback',
					'dox_pill_handshake',
					'dox_informed_consent_couple',
					'dox_EHRvideo_game',
					'dox_mental_load',
					'dox_oxygen_mask',
					'dox_phone_fear',
					'dox_match',
					'dox_strength_training',
					'dox_codeSwitching',
					'dox_portalMagicWand',
					'dox_flowchartChange',
					'dox_shadowHands',
					'dox_socialSafetyNet',
					'dox_languageBarrier',
					'dox_sparkChain',
					'dox_bestHospitals',
					'dox_1stepForward',
					'dox_blackBelt_whiteCoat',
					'dox_RN_vs_NP',
					'dox_hobbies',
					'dox_AIclearPath',
					'dox_AIinTheWay',
					'dox_klax',
					'dox_collage_compare_vials',
					'dox_ozempic_collage',
					'dox_MRI_glitch',
					'dox_age_is_a_funny_thing',
					'dox_union',
					'dox_golden_rule_book',
					'dox_thinker',
					'dox_phone_notifs',
					'dox_AI_handshake',
					'dox_son_of_man_AI',
					'dox_then_vs_now',
					'dox_plane',
					'dox_microscope',
					'dox_speech_bubbles_v2',
					'dox_stepping_stones',
					'dox_safety_pins',
					'dox_turn_every_stone',
					'dox_FDA_loadBar',
					'dox_empathy_waves',
					'dox_preg_cancer_pt',
					'dox_polishing_diamond_v2',
					'dox_template_hands_meds',
					'dox_wim_letter_to_self',
					'dox_age_descrimination',
					'dox_parental_leave',
					'dox_venn_diagram_v2',
					'dox_micro_vs_macro',
					'dox_medical_van',
					'dox_leadership_boat',
					'dox_extreme_exercise',
					'dox_crystal_ball',
					'dox_hockey',
					'dox_empathy_brain',
					'dox_8_ball',
					'dox_airplanePatient',
					'dox_relay_baton',
					'dox_black_girl_magic',
					'dox_handshake_series3',
					//'dox_invisible_illness',
					'dox_green_door',
					'dox_medical_retraumatization',
					'dox_vaccine_syringe',
					'dox_suture_tails',
					'dox_flyers',
					'dox_coffee_mugs',
					'dox_socialDistancing',
					'dox_silhouette_awards',
					'dox_standardized_patient',
					'dox_waiting_room',
					'dox_poetry',
					'dox_mindset_shift_v2',
					'dox_covidTarot',
					'dox_improving_residency',
					'dox_personality_tests',
					'dox_racist_algo',
					'dox_video_games',
				]
			},
			
			{
				id: 'childrens',
				label: `Children's`,
				projects: [
					'myCondition',
					'activity',
					'achieve',

					'pathways',
					//'thesis',
					'frida',
					'fall',
					'energy',
					'bunny',
					'trump',
					'color',
					'andreaBook',
				
					'goingForGold',
					// 'expii',
					't1d',
					'Hbook',
				]
			},

			{
				id: 'expii',
				label: `E-Learning`,
				projects: [
					'ornaments',
					'expii_oscars',
					'turkey',
					'expii_waffle',
					'pumpkins',
					'expii_winter_olympics',
					'clock',
					'expii_presidents_day',
					'hanukkah',
					'expii_chinese_new_year',
					'bFriday',
					'expii_groundhog',
					'skulls',
					'expii_KID_day',
					'ribbon',
					'NYE',

					
					
					
					
					
					
					

					
					'expii_total_eclipse',
					'expii_pluto_demoted_day',
					'expii_cat_day',
					'expii_tau_day',
					'expii_chess_day',
					'expii_pi_approximation_day',
				]
			},


			{
				id: 'media',
				label: 'Media',
				projects: [
					'grataCanisMajor',
					'expiiMedia1',
					'expiiMedia2',
					'hotspots',
					
					'infographics',
					'flipfoot',
					'saveTheDate',

					'lloyd',


					'verdeBaby',
					'verdeGun',
					'verdeElephant',
					'verdeSam',
					'verdeSweetheart',
					'verdeLips',
					'verdeOccupy',
					'verdeInternal',
					
					'colorShadowGirl',
					'birb',
					//'icyGirl',
				]
			},

			{
				id: 'iconography',
				label: 'Iconography',
				projects: [
					'thesis',
					'tobiiObjects',
					'tobiiPeople',
					'tobiiTopographic',
					'tobiiASL',
					'tobiiTech',
					//'tobiiAnimals',
					'tobiiHospital',
					'expiiIcons',
					'tobiiAvatars',
				]
			},

		]
	},

	{
		id: 'animation',
		label: 'Animation',
		submenu: [
			
			{
				id: 'loops',
				label: 'Loops',
				projects: [
					'inktoberSandWitch',
					'inktoberPinecone',
					'inktoberFolliage',

					
					
					'inktoberCampfire',
					'inktoberOwl',
					'inktoberTrickOrTreat',
					'inktoberCider',
					'inktoberShroomPizza',
					'inktoberPaperWitch',

					'inktoberSweater',
					'inktoberBat',
					'inktoberCandyCorn',

					'inktoberCat',
					'inktoberScarecrow',
					'inktoberScarf',

					'inktoberApples',
					'inktoberHauntedHouse',
					'inktoberSpider',

					'inktoberMoon',
					'inktoberAcorns',
					//'inktoberBouquet',
					'inktoberShroomHat',

					'skulls',
					'turkey',
					'pumpkins',
					'clock',
					'hanukkah',
					'bFriday',
					'ornaments',
					'ribbon',
					'NYE',
					'dadMotorcycle',
					'banana',
					'heart',
				]
			},

			{
				id: 'videos',
				label: `Videos`,
				projects: [
					'holiday',
					'iconExplainer',
					'characterExplainer',
					'textAnimation',
					'dadCard',
					'whiteboard',
					'frameByFrame',
					'transitionScreens',
					'assetCreation',
				
				]
			},

		]
	},

	{
		id: 'art',
		label: 'Art',
		submenu: [
			{
				id: 'drawing',
				label: `Drawing`,
				projects: [

					'joker',
					'jackson',
					'alyssa',
					
					'selfPencil',
					'stillLifePencil',
					'shell',
					
					'handCharcoal',
					'charcoal',
					'orangeDrawing',
					
					
					'figure5',
					'figure3',
					'inkHair',
					//'figure4',
					//'figure1',
					//'figure2',
					
				]
			},

			{
				id: 'painting',
				label: 'Painting',
				projects: [
					'botanical1',

					'dissect',
					'eye',

					

					

					'young4',
					'young2',
					'young5',

					'young7',
					'model',
					'young8',

					'plane',
					

					//'boobs',
					
					//'botanical2',
					//'botanical3',
					//'botanical4',
					
					//'jesusme',
				]
			},

			{
				id: 'mixed media',
				label: 'Mixed Media',
				projects: [
					
					'rococoLint',
					'Lint',
					
					'blueWave',
					'migraineGlasses',
					'darwinPortraits',

					'artBioPetri',
					'hairGod',
					
					'spider',

					'tattoo',
					
					'ducks',
					'dreamBox',
					
					

					'sugarBoxes',
					'spaceArt',
					//'wonky1',
					'wonky2',
					//'phenotype',
					
					
				]
			},

			{
				id: 'code',
				label: 'Code',
				projects: [
					'104eyes',
					'104bodyCards',
					'104city',

					'104faces',
					'104colorSliders',
					'104walkingMan',
					'104dragMouseRainbowBalls',

					
					'104paddleBall',
					'104yinAndYang',

					'104peaches',
					'104turtlesRacing',
					'104marioGame',

					

					'104fourPieChart',
					'104saraPortrait',
					'104pinkClock',

					

					'104soundBall',
					'104flagMountains',
					
				]
			},
		]
	},

	{
		id: 'design',
		label: 'Design',
		submenu: [
			{
				id: 'graphic',
				label: `Graphic`,
				projects: [
					'grataCanisMajor',
					'indesign',
					'infographics',
					'saveTheDate',
					'flipfoot',
					'sparkBranding',
					'expiiFlyer',
					
					
					'CIAJ',
					'postcards',
					'starMap',
					
					'verdeShirt',
					//'pirateShirt',
					'tobiiShirt',
					//'snellen',
				]
			},

			{
				id: 'craft',
				label: 'Craft',
				projects: [
					
					'resinBookmarks',
					'dadCo',
					'bathSalts',
					'paperFlowers',
				
					
					'greetingCards',
					'cal',
					
					//'HstarGift',
					'blueSoap',
					'punkNecklace',
					'nail-nyc',
					'urn',
					
					'momPillow',
					//'soaps',
					//'saraBook',					
				]
			},

			{
				id: 'lettering',
				label: 'Lettering',
				projects: [
					'lettering-board1',
					'lettering-sign2',
					'kidFont',
					'lettering-cmu2',
					'lettering-cmu1',
					'jabberwocky',
					
					
					//'lettering-letter1',
					//'cal',
				]
			},
		]
	},

	{
		id: 'about',
		label: 'About',
	},
];

// cleanup
menu.forEach(item => {
	if(!item.submenu && !item.projects) item.projects = [];
	if(item.submenu) item.submenu.forEach(sub => {
		if(!sub.projects) sub.projects = [];
	})
})
const flat = menu.reduce((all, item) => [...all, item, ...(item.submenu || [])], []);

export {
	menu,
	flat
}
